import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bin"
const BinIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.5 17.25H9V9.75H10.5zM15 17.25H13.5V9.75H15z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C12.995 1.5 13.948 1.895 14.651 2.599 15.175 3.122 15.528 3.785 15.674 4.5H18.62Q18.686 4.5 18.75 4.507V4.5H21.75C21.75 5.328 21.078 6 20.25 6H20.118Q20.118 6.062 20.115 6.125L18.865 21.125C18.803 21.853 18.228 22.425 17.514 22.493L17.37 22.5H6.63C5.899 22.5 5.282 21.974 5.154 21.268L5.136 21.125 3.886 6.125Q3.88 6.062 3.88 6H3.75C2.922 6 2.25 5.328 2.25 4.5H5.25V4.507L5.38 4.5H8.326C8.472 3.785 8.825 3.122 9.35 2.599 10.052 1.895 11.005 1.5 12 1.5M6.63 21H17.37L18.62 6H5.38zM12 3C11.403 3 10.831 3.237 10.41 3.66 10.17 3.897 9.992 4.186 9.881 4.5H14.118C14.008 4.187 13.83 3.898 13.591 3.66 13.169 3.236 12.597 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default BinIcon
